import type {Intent} from '../intent';
import {createArrayIntentType} from '../intent';
import type {StyleXStyles} from '../stylex/intent';
import type {Style} from './types';

export const decorateStyleIntent = createArrayIntentType(
  'StyleIntent',
  (decorate) =>
    (styles: Style.LazyStyles): Style.Intent =>
      decorate(styles),
);

type LazyStyleIntent = <
  Properties extends Style.Properties,
  Input extends Style.Input<Style.InputShape<Properties>>,
>(
  styles: Input,
  computedStyles?: StyleXStyles | undefined,
) => [Input, StyleXStyles | undefined] &
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Intent<any>;

type LazyGlobalStyleIntent = <
  Properties extends Style.Properties,
  Input extends Style.GlobalInput<Style.InputShape<Properties>>,
>(
  styles: Input,
) => Input &
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  Intent<any>;

export const lazyStyleIntent = createArrayIntentType<LazyStyleIntent>(
  'LazyStyleIntent',
  (decorate) => (styles, computedStyles) => decorate([styles, computedStyles]),
);

export const lazyGlobalStyleIntent =
  createArrayIntentType<LazyGlobalStyleIntent>(
    'LazyGlobalStyleIntent',
    (decorate) => (styles) => decorate(styles),
  );
